/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/helpers/format-money.js":
/*!****************************************!*\
  !*** ./src/js/helpers/format-money.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
var formatMoney = function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || '${{amount}}';
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  var value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

/***/ }),

/***/ "./src/js/modules/accessibility.js":
/*!*****************************************!*\
  !*** ./src/js/modules/accessibility.js ***!
  \*****************************************/
/***/ (() => {

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Accessibility Enhancement for Product Swatches
 * Implements roving tabindex pattern for radio groups (role="radio").
 * Tab moves focus into the group; arrow keys navigate between swatches.
 * Handles dynamically loaded swatches using MutationObserver.
 */

document.addEventListener('DOMContentLoaded', function () {
  var SWATCH_SELECTOR = 'li.swatch-view-item';
  var DATA_ATTRIBUTE = 'data-accessibility-attached';
  function getGroup(item) {
    return item.closest('ul, [role="radiogroup"]');
  }
  function getSiblings(item) {
    var group = getGroup(item);
    if (!group) return [];
    return Array.from(group.querySelectorAll(SWATCH_SELECTOR));
  }
  function setRovingFocus(item) {
    var siblings = getSiblings(item);
    siblings.forEach(function (s) {
      return s.setAttribute('tabindex', '-1');
    });
    item.setAttribute('tabindex', '0');
    item.focus();
  }
  function attachSwatchListeners() {
    var newSwatchItems = document.querySelectorAll("".concat(SWATCH_SELECTOR, ":not([").concat(DATA_ATTRIBUTE, "])"));
    if (newSwatchItems.length === 0) return;
    newSwatchItems.forEach(function (item) {
      item.setAttribute(DATA_ATTRIBUTE, 'true');
      // Default all new items to -1; initGroup will promote the right one.
      item.setAttribute('tabindex', '-1');
      item.addEventListener('keydown', handleSwatchKeydown);
    });

    // For each group that has new items, ensure exactly one has tabindex="0".
    var affectedGroups = new Set();
    newSwatchItems.forEach(function (item) {
      var group = getGroup(item);
      if (group) affectedGroups.add(group);
    });
    affectedGroups.forEach(function (group) {
      var items = Array.from(group.querySelectorAll(SWATCH_SELECTOR));
      var checked = items.find(function (i) {
        return i.getAttribute('aria-checked') === 'true';
      });
      var target = checked || items[0];
      if (target && target.getAttribute('tabindex') !== '0') {
        target.setAttribute('tabindex', '0');
      }

      // Nav arrows have role="presentation" — remove them from tab order
      // so Tab exits the swatch component cleanly
      var wrapper = group.closest('.swatch-navigable');
      if (wrapper) {
        wrapper.querySelectorAll('.swatch-navigation[tabindex="0"]').forEach(function (nav) {
          nav.setAttribute('tabindex', '-1');
        });
      }
    });
  }
  function handleSwatchKeydown(e) {
    var siblings = getSiblings(this);
    var currentIndex = siblings.indexOf(this);
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      var next = siblings[(currentIndex + 1) % siblings.length];
      setRovingFocus(next);
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      var prev = siblings[(currentIndex - 1 + siblings.length) % siblings.length];
      setRovingFocus(prev);
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      // Click the inner .swatch-selector — the li itself has no click handler
      var inner = this.querySelector('.swatch-selector') || this;
      inner.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
        detail: 1
      }));
    } else if (e.key === 'Escape' || e.key === 'Tab') {
      var _getGroup;
      e.preventDefault();
      var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      var container = ((_getGroup = getGroup(this)) === null || _getGroup === void 0 ? void 0 : _getGroup.closest('.swatch-navigable')) || getGroup(this);
      if (!container) return;
      var all = Array.from(document.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return !container.contains(el);
      });
      if (e.shiftKey) {
        var _prev2;
        var _prev = all.filter(function (el) {
          return container.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_PRECEDING;
        });
        (_prev2 = _prev[_prev.length - 1]) === null || _prev2 === void 0 || _prev2.focus();
      } else {
        var _next = all.find(function (el) {
          return container.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING;
        });
        _next === null || _next === void 0 || _next.focus();
      }
    }
  }
  function disableImageWrapperLinks() {
    document.querySelectorAll('.product-item__image-wrapper a:not([tabindex="-1"])').forEach(function (link) {
      link.setAttribute('tabindex', '-1');
    });
  }
  attachSwatchListeners();
  disableImageWrapperLinks();
  var observer = new MutationObserver(function (mutations) {
    var shouldCheck = false;
    var _iterator = _createForOfIteratorHelper(mutations),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          var _iterator2 = _createForOfIteratorHelper(mutation.addedNodes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _node$matches, _node$querySelector;
              var node = _step2.value;
              if (node.nodeType === Node.ELEMENT_NODE && ((_node$matches = node.matches) !== null && _node$matches !== void 0 && _node$matches.call(node, SWATCH_SELECTOR) || (_node$querySelector = node.querySelector) !== null && _node$querySelector !== void 0 && _node$querySelector.call(node, SWATCH_SELECTOR))) {
                shouldCheck = true;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (shouldCheck) break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (shouldCheck) {
      attachSwatchListeners();
      disableImageWrapperLinks();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/***/ }),

/***/ "./src/js/modules/ed-ab-lk-3-delivery-date.js":
/*!****************************************************!*\
  !*** ./src/js/modules/ed-ab-lk-3-delivery-date.js ***!
  \****************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var AB_CLASS = 'ed-ab-lk-3';
var CUTOFF_HOUR = 11;
var CUTOFF_MINUTE = 30;
var DELIVERY_DAYS = 2;
var TZ = 'Europe/Berlin';
var WEEKDAY_PLACEHOLDER = '@weekday@';
var HOLIDAYS = ['2026-01-01', '2026-04-03', '2026-04-06', '2026-05-01', '2026-05-14', '2026-05-25', '2026-10-03', '2026-12-25', '2026-12-26', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17', '2027-10-03', '2027-12-25', '2027-12-26'];
function isEnabled() {
  return document.documentElement.classList.contains(AB_CLASS);
}
function berlinParts(date) {
  var dtf = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    weekday: 'short',
    hour12: false
  });
  var parts = {};
  dtf.formatToParts(date).forEach(function (p) {
    parts[p.type] = p.value;
  });
  var weekdayMap = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6
  };
  var hour = parseInt(parts.hour, 10);
  if (hour === 24) hour = 0;
  return {
    year: parseInt(parts.year, 10),
    month: parseInt(parts.month, 10),
    day: parseInt(parts.day, 10),
    weekdayIndex: weekdayMap[parts.weekday],
    hour: hour,
    minute: parseInt(parts.minute, 10)
  };
}
function iso(y, m, d) {
  var mm = String(m).padStart(2, '0');
  var dd = String(d).padStart(2, '0');
  return "".concat(y, "-").concat(mm, "-").concat(dd);
}
function isShippingDay(y, m, d, weekdayIndex) {
  if (weekdayIndex === 0 || weekdayIndex === 6) return false;
  if (HOLIDAYS.indexOf(iso(y, m, d)) !== -1) return false;
  return true;
}
function isDeliveryDay(y, m, d, weekdayIndex) {
  if (weekdayIndex === 0) return false;
  if (HOLIDAYS.indexOf(iso(y, m, d)) !== -1) return false;
  return true;
}
function nextShippingDay(utcDate) {
  var d = new Date(utcDate.getTime());
  do {
    d.setUTCDate(d.getUTCDate() + 1);
  } while (!isShippingDay(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate(), d.getUTCDay()));
  return d;
}
function nextDeliveryDay(utcDate) {
  var d = new Date(utcDate.getTime());
  do {
    d.setUTCDate(d.getUTCDate() + 1);
  } while (!isDeliveryDay(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate(), d.getUTCDay()));
  return d;
}
function computeDelivery(now) {
  var b = berlinParts(now);
  var cursor = new Date(Date.UTC(b.year, b.month - 1, b.day));
  var beforeCutoff = b.hour < CUTOFF_HOUR || b.hour === CUTOFF_HOUR && b.minute <= CUTOFF_MINUTE;
  var todayCanShip = isShippingDay(b.year, b.month, b.day, b.weekdayIndex);
  if (!(todayCanShip && beforeCutoff)) {
    cursor = nextShippingDay(cursor);
  }
  for (var i = 0; i < DELIVERY_DAYS; i++) {
    cursor = nextDeliveryDay(cursor);
  }
  return cursor;
}
function weekdayName(utcDate, locale) {
  return new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    timeZone: 'UTC'
  }).format(utcDate);
}
var EdAbDeliveryDate = /*#__PURE__*/function (_HTMLElement) {
  function EdAbDeliveryDate() {
    _classCallCheck(this, EdAbDeliveryDate);
    return _callSuper(this, EdAbDeliveryDate, arguments);
  }
  _inherits(EdAbDeliveryDate, _HTMLElement);
  return _createClass(EdAbDeliveryDate, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      try {
        if (window.Shopify && window.Shopify.designMode) return;
        this._inventory = this.querySelector('[data-product-inventory]');
        if (!this._inventory) return;
        this._locale = (document.documentElement.getAttribute('lang') || '').toLowerCase().startsWith('en') ? 'en-GB' : 'de-DE';
        this._withCutoff = this.dataset.withCutoff || '';
        this._noCutoff = this.dataset.noCutoff || '';
        this._rangeSuffix = this.dataset.rangeSuffix || '';
        this._lowstockDelivery = this.dataset.lowstockDelivery || '';
        this._productContainer = this.closest('[data-section-type], .product-single, .product') || document;
        this._onVariantChange = this._onVariantChange.bind(this);
        this._onPageShow = this._onPageShow.bind(this);
        this._productContainer.addEventListener('variantChange', this._onVariantChange);
        window.addEventListener('pageshow', this._onPageShow);
        if (isEnabled()) {
          this._apply();
        } else {
          this._htmlObserver = new MutationObserver(function () {
            if (isEnabled()) {
              _this._htmlObserver.disconnect();
              _this._htmlObserver = null;
              _this._apply();
            }
          });
          this._htmlObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
      } catch (e) {
        if (window.console) console.warn('[LK-3] init failed', e);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this._productContainer) {
        this._productContainer.removeEventListener('variantChange', this._onVariantChange);
      }
      window.removeEventListener('pageshow', this._onPageShow);
      if (this._htmlObserver) {
        this._htmlObserver.disconnect();
        this._htmlObserver = null;
      }
    }
  }, {
    key: "_onVariantChange",
    value: function _onVariantChange() {
      var _this2 = this;
      window.requestAnimationFrame(function () {
        return _this2._apply();
      });
    }
  }, {
    key: "_onPageShow",
    value: function _onPageShow(event) {
      if (event.persisted) this._apply();
    }
  }, {
    key: "_apply",
    value: function _apply() {
      try {
        if (!isEnabled()) return;
        if (!this._inventory) return;
        var parent = this._inventory.parentNode;
        var block = this._inventory.closest('.product-block');
        if (block && block.classList.contains('hide')) return;
        if (parent && parent.classList.contains('hide')) return;
        var delivery = computeDelivery(new Date());
        var weekday = weekdayName(delivery, this._locale);
        var isLowStock = parent && parent.classList.contains('inventory--low');
        var text;
        if (isLowStock) {
          var current = this._inventory.textContent.trim();
          var lowDelivery = this._lowstockDelivery.replace(WEEKDAY_PLACEHOLDER, weekday);
          if (this._rangeSuffix && current.indexOf(this._rangeSuffix) !== -1) {
            text = current.replace(this._rangeSuffix, lowDelivery);
          } else if (current.indexOf(lowDelivery) !== -1) {
            return;
          } else {
            text = current + lowDelivery;
          }
        } else {
          var template = this._pickTemplate();
          if (!template) return;
          text = template.replace(WEEKDAY_PLACEHOLDER, weekday);
        }
        if (this._inventory.textContent !== text) {
          this._inventory.textContent = text;
        }
      } catch (e) {
        if (window.console) console.warn('[LK-3] apply failed', e);
      }
    }
  }, {
    key: "_pickTemplate",
    value: function _pickTemplate() {
      var b = berlinParts(new Date());
      var beforeCutoff = b.hour < CUTOFF_HOUR || b.hour === CUTOFF_HOUR && b.minute <= CUTOFF_MINUTE;
      var todayCanShip = isShippingDay(b.year, b.month, b.day, b.weekdayIndex);
      return todayCanShip && beforeCutoff ? this._withCutoff : this._noCutoff;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-ab-delivery-date')) {
  customElements.define('ed-ab-delivery-date', EdAbDeliveryDate);
}

/***/ }),

/***/ "./src/js/modules/ed-ab-lk-5-sticky-atc.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-ab-lk-5-sticky-atc.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }


// LK-5 A/B test: mobile sticky add-to-cart bar (product-template.liquid).
// Keeps price/variant/button state in sync on variant changes and toggles the
// attributes the slide-out CSS reads while the buy-box button or footer is in
// view. Visibility itself is pure CSS, gated on html.ed-ab-lk-5.
var EdStickyAtc = /*#__PURE__*/function (_HTMLElement) {
  function EdStickyAtc() {
    _classCallCheck(this, EdStickyAtc);
    return _callSuper(this, EdStickyAtc, arguments);
  }
  _inherits(EdStickyAtc, _HTMLElement);
  return _createClass(EdStickyAtc, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this._observeVisibility();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$visibilityObser;
      (_this$visibilityObser = this.visibilityObserver) === null || _this$visibilityObser === void 0 || _this$visibilityObser.disconnect();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.container = this.closest('[data-section-type="product"]');
      this.priceElement = this.querySelector('[data-ed-sticky-atc-price]');
      this.variantElement = this.querySelector('[data-ed-sticky-atc-variant]');
      this.buttonElement = this.querySelector('[data-ed-sticky-atc-button]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this$container;
      (_this$container = this.container) === null || _this$container === void 0 || _this$container.addEventListener('variantChange', this.handleVariantChange.bind(this));
    }
  }, {
    key: "handleVariantChange",
    value: function handleVariantChange(event) {
      var variant = event.detail.variant;
      if (!variant) {
        return;
      }
      if (this.priceElement) {
        var moneyFormat = window.theme && window.theme.settings ? window.theme.settings.moneyFormat : '{{amount_with_comma_separator}} €';
        this.priceElement.innerHTML = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(variant.price, moneyFormat);
      }
      if (this.variantElement && variant.title) {
        var title = variant.title;
        this.variantElement.textContent = " \xB7 ".concat(title.charAt(0).toUpperCase()).concat(title.slice(1));
      }
      if (this.buttonElement) {
        this.buttonElement.disabled = !variant.available;
        this.buttonElement.textContent = variant.available ? this.buttonElement.dataset.defaultText : this.buttonElement.dataset.soldOutText;
      }
    }
  }, {
    key: "_observeVisibility",
    value: function _observeVisibility() {
      var _this$container2,
        _this = this;
      var watched = [{
        element: (_this$container2 = this.container) === null || _this$container2 === void 0 ? void 0 : _this$container2.querySelector('form [data-add-to-cart]'),
        attribute: 'data-ed-buybox-visible'
      }, {
        element: document.querySelector('footer.site-footer'),
        attribute: 'data-ed-footer-visible'
      }].filter(function (item) {
        return item.element;
      });
      if (!watched.length) {
        return;
      }
      this.visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var match = watched.find(function (item) {
            return item.element === entry.target;
          });
          _this.toggleAttribute(match.attribute, entry.intersectionRatio > 0);
        });
      });
      watched.forEach(function (item) {
        return _this.visibilityObserver.observe(item.element);
      });
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-sticky-atc')) {
  customElements.define('ed-sticky-atc', EdStickyAtc);
}

/***/ }),

/***/ "./src/js/modules/ed-cart-shipping.js":
/*!********************************************!*\
  !*** ./src/js/modules/ed-cart-shipping.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var EdCartShipping = /*#__PURE__*/function (_HTMLElement) {
  function EdCartShipping() {
    _classCallCheck(this, EdCartShipping);
    return _callSuper(this, EdCartShipping, arguments);
  }
  _inherits(EdCartShipping, _HTMLElement);
  return _createClass(EdCartShipping, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._form = this.closest('#CartDrawerForm');
      if (!this._form) return;
      this._config = {
        thresholdDe: parseInt(this.dataset.thresholdDe, 10) || 4900,
        shippingDe: parseInt(this.dataset.shippingDe, 10) || 390,
        shippingEu: parseInt(this.dataset.shippingEu, 10) || 890,
        country: (this.dataset.country || 'DE').toUpperCase(),
        euCountries: (this.dataset.euCountries || '').split(',').map(function (code) {
          return code.trim().toUpperCase();
        }).filter(Boolean),
        remainingMessage: this.dataset.remainingMessage || '',
        qualifiedMessage: this.dataset.qualifiedMessage || '',
        qualifiedHint: this.dataset.qualifiedHint || '',
        deliveryHint: this.dataset.deliveryHint || '',
        labelDe: this.dataset.labelDe || '',
        labelEu: this.dataset.labelEu || '',
        freeLabel: this.dataset.freeLabel || ''
      };
      this._attachSelectors();
      this._bindHandlers();
      this._attachListeners();
      this._fetchAndUpdate();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._detachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this._progress = this._form.querySelector('[data-ed-shipping-progress]');
      this._message = this._form.querySelector('[data-ed-shipping-message]');
      this._bar = this._form.querySelector('[data-ed-shipping-bar]');
      this._barFill = this._form.querySelector('[data-ed-shipping-bar-fill]');
      this._hint = this._form.querySelector('[data-ed-shipping-hint]');
      this._summary = this._form.querySelector('[data-ed-shipping-summary]');
      this._shippingLabel = this._form.querySelector('[data-ed-shipping-label]');
      this._shippingCost = this._form.querySelector('[data-ed-shipping-cost]');
      this._total = this._form.querySelector('[data-ed-shipping-total]');
    }
  }, {
    key: "_bindHandlers",
    value: function _bindHandlers() {
      this._onCartUpdated = this._onCartUpdated.bind(this);
      this._onCartBuild = this._onCartBuild.bind(this);
      this._onProductAdded = this._onProductAdded.bind(this);
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('cart:updated', this._onCartUpdated);
      document.addEventListener('cart:build', this._onCartBuild);
      document.addEventListener('ajaxProduct:added', this._onProductAdded);
    }
  }, {
    key: "_detachListeners",
    value: function _detachListeners() {
      document.removeEventListener('cart:updated', this._onCartUpdated);
      document.removeEventListener('cart:build', this._onCartBuild);
      document.removeEventListener('ajaxProduct:added', this._onProductAdded);
    }
  }, {
    key: "_onCartUpdated",
    value: function _onCartUpdated(event) {
      if (event.detail && event.detail.cart) {
        this._update(event.detail.cart);
      }
    }
  }, {
    key: "_onCartBuild",
    value: function _onCartBuild() {
      this._fetchAndUpdate();
    }
  }, {
    key: "_onProductAdded",
    value: function _onProductAdded() {
      this._fetchAndUpdate();
    }
  }, {
    key: "_fetchAndUpdate",
    value: function _fetchAndUpdate() {
      var _this = this;
      fetch('/cart.js', {
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        return _this._update(cart);
      })["catch"](function () {});
    }
  }, {
    key: "_resolveMarket",
    value: function _resolveMarket() {
      var _this$_config = this._config,
        country = _this$_config.country,
        euCountries = _this$_config.euCountries;
      if (country === 'DE') {
        return 'de';
      }
      if (euCountries.indexOf(country) !== -1) {
        return 'eu';
      }
      return 'other';
    }
  }, {
    key: "_format",
    value: function _format(cents) {
      var moneyFormat = window.theme && window.theme.settings ? window.theme.settings.moneyFormat : '{{amount_with_comma_separator}} €';
      return (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(cents, moneyFormat);
    }
  }, {
    key: "_setVisibility",
    value: function _setVisibility(isVisible) {
      if (this._progress) {
        this._progress.hidden = !isVisible;
      }
      if (this._summary) {
        this._summary.hidden = !isVisible;
      }
    }
  }, {
    key: "_updateProgress",
    value: function _updateProgress(subtotal, market) {
      if (!this._progress || market !== 'de') {
        if (this._progress) {
          this._progress.hidden = true;
        }
        return;
      }
      this._progress.hidden = false;
      var _this$_config2 = this._config,
        thresholdDe = _this$_config2.thresholdDe,
        remainingMessage = _this$_config2.remainingMessage,
        qualifiedMessage = _this$_config2.qualifiedMessage,
        qualifiedHint = _this$_config2.qualifiedHint,
        deliveryHint = _this$_config2.deliveryHint;
      var isQualified = subtotal >= thresholdDe;
      var remaining = Math.max(0, thresholdDe - subtotal);
      var progress = thresholdDe > 0 ? Math.min(100, Math.round(subtotal / thresholdDe * 100)) : 100;
      this._progress.classList.toggle('ed-cart-shipping__progress--qualified', isQualified);
      if (this._message) {
        this._message.classList.toggle('ed-cart-shipping__message--qualified', isQualified);
        if (isQualified) {
          this._message.textContent = qualifiedMessage;
        } else {
          var amount = this._format(remaining);
          this._message.innerHTML = remainingMessage.replace('[amount]', "<strong>".concat(amount, "</strong>"));
        }
      }
      if (this._bar && this._barFill) {
        this._bar.setAttribute('aria-valuenow', String(progress));
        this._barFill.style.width = "".concat(progress, "%");
      }
      if (this._hint) {
        var hintText = isQualified ? qualifiedHint : deliveryHint;
        this._hint.textContent = hintText;
        this._hint.hidden = !hintText;
      }
    }
  }, {
    key: "_updateSummary",
    value: function _updateSummary(subtotal, market) {
      if (!this._summary) return;
      var _this$_config3 = this._config,
        shippingDe = _this$_config3.shippingDe,
        shippingEu = _this$_config3.shippingEu,
        labelDe = _this$_config3.labelDe,
        labelEu = _this$_config3.labelEu,
        freeLabel = _this$_config3.freeLabel;
      var shippingCents = 0;
      var label = '';
      if (market === 'de') {
        label = labelDe;
        shippingCents = subtotal >= this._config.thresholdDe ? 0 : shippingDe;
      } else if (market === 'eu') {
        label = labelEu;
        shippingCents = shippingEu;
      }
      if (this._shippingLabel) {
        this._shippingLabel.textContent = label;
      }
      if (this._shippingCost) {
        var isFree = shippingCents === 0;
        this._shippingCost.textContent = isFree ? freeLabel : this._format(shippingCents);
        this._shippingCost.classList.toggle('ed-cart-shipping__cost--free', isFree);
      }
      if (this._total) {
        this._total.textContent = this._format(subtotal + shippingCents);
      }
    }
  }, {
    key: "_update",
    value: function _update(cart) {
      var market = this._resolveMarket();
      if (!cart || cart.item_count === 0 || market === 'other') {
        this._setVisibility(false);
        return;
      }
      this._setVisibility(true);
      var subtotal = cart.total_price || 0;
      this._updateProgress(subtotal, market);
      this._updateSummary(subtotal, market);
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-cart-shipping')) {
  customElements.define('ed-cart-shipping', EdCartShipping);
}

/***/ }),

/***/ "./src/js/modules/ed-cart-upsell.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-cart-upsell.js ***!
  \******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var REFRESH_DELAY = 250;
var IMPRESSION_THRESHOLD = 0.5;
var REMOVE_DURATION = 300;
function routesRoot() {
  return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
}
var EdCartUpsell = /*#__PURE__*/function (_HTMLElement) {
  function EdCartUpsell() {
    _classCallCheck(this, EdCartUpsell);
    return _callSuper(this, EdCartUpsell, arguments);
  }
  _inherits(EdCartUpsell, _HTMLElement);
  return _createClass(EdCartUpsell, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._config = {
        url: this.dataset.url || '/recommendations/products',
        sectionId: this.dataset.sectionId || 'ed-cart-upsell',
        limit: parseInt(this.dataset.limit, 10) || 3,
        maxAnchors: parseInt(this.dataset.maxAnchors, 10) || 3,
        errorMessage: this.dataset.errorMessage || ''
      };
      this._cache = new Map();
      this._requestId = 0;
      this._impressionTracked = false;
      this._pendingRefresh = false;
      this._keepOrder = false;
      this._attachSelectors();
      this._bindHandlers();
      this._attachListeners();
      this._observeReveal();
      this._scheduleRefresh();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._detachListeners();
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this._wrapper = this.querySelector('[data-ed-upsell-wrapper]');
      this._list = this.querySelector('[data-ed-upsell-list]');
    }
  }, {
    key: "_bindHandlers",
    value: function _bindHandlers() {
      this._onCartChange = this._onCartChange.bind(this);
      this._onClick = this._onClick.bind(this);
      this._onChange = this._onChange.bind(this);
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ajaxProduct:added', this._onCartChange);
      document.addEventListener('cart:build', this._onCartChange);
      document.addEventListener('cart:updated', this._onCartChange);
      this.addEventListener('click', this._onClick);
      this.addEventListener('change', this._onChange);
    }
  }, {
    key: "_detachListeners",
    value: function _detachListeners() {
      document.removeEventListener('ajaxProduct:added', this._onCartChange);
      document.removeEventListener('cart:build', this._onCartChange);
      document.removeEventListener('cart:updated', this._onCartChange);
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('change', this._onChange);
    }
  }, {
    key: "_isEnabled",
    value: function _isEnabled() {
      return window.getComputedStyle(this).display !== 'none';
    }
  }, {
    key: "_observeReveal",
    value: function _observeReveal() {
      var _this = this;
      if (!('ResizeObserver' in window)) return;
      this._resizeObserver = new ResizeObserver(function () {
        if (_this._pendingRefresh && _this._isEnabled()) {
          _this._scheduleRefresh();
        }
      });
      this._resizeObserver.observe(this);
    }
  }, {
    key: "_onCartChange",
    value: function _onCartChange() {
      this._scheduleRefresh();
    }
  }, {
    key: "_scheduleRefresh",
    value: function _scheduleRefresh() {
      var _this2 = this;
      clearTimeout(this._refreshTimer);
      this._refreshTimer = setTimeout(function () {
        return _this2._refresh();
      }, REFRESH_DELAY);
    }
  }, {
    key: "_refresh",
    value: function _refresh() {
      var _this3 = this;
      if (!this._isEnabled()) {
        this._pendingRefresh = true;
        return;
      }
      this._pendingRefresh = false;
      var requestId = ++this._requestId;
      fetch("".concat(routesRoot(), "cart.js"), {
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        return _this3._loadRecommendations(cart);
      }).then(function (items) {
        if (requestId !== _this3._requestId) return;
        _this3._render(items);
      })["catch"](function () {
        if (requestId !== _this3._requestId) return;
        _this3._render([]);
      });
    }
  }, {
    key: "_loadRecommendations",
    value: function _loadRecommendations(cart) {
      var _this4 = this;
      var cartItems = cart && cart.items || [];
      var cartProductIds = new Set(cartItems.map(function (item) {
        return String(item.product_id);
      }));
      var cartTypes = new Set(cartItems.map(function (item) {
        return (item.product_type || '').trim().toLowerCase();
      }).filter(Boolean));
      var anchors = Array.from(cartProductIds).slice(0, this._config.maxAnchors);
      if (!anchors.length) {
        return Promise.resolve([]);
      }
      return Promise.all(anchors.map(function (id) {
        return _this4._fetchAnchor(id);
      })).then(function (results) {
        var seen = new Set();
        var items = [];
        results.forEach(function (nodes) {
          nodes.forEach(function (node) {
            var productId = node.dataset.productId;
            var productType = (node.dataset.productType || '').trim().toLowerCase();
            if (seen.has(productId) || cartProductIds.has(productId)) return;
            if (productType && cartTypes.has(productType)) return;
            seen.add(productId);
            items.push(node);
          });
        });
        return items.slice(0, _this4._config.limit);
      });
    }
  }, {
    key: "_fetchAnchor",
    value: function _fetchAnchor(productId) {
      var _this5 = this;
      if (this._cache.has(productId)) {
        return this._cache.get(productId);
      }
      var _this$_config = this._config,
        url = _this$_config.url,
        sectionId = _this$_config.sectionId;
      var request = fetch("".concat(url, "?section_id=").concat(sectionId, "&product_id=").concat(productId, "&limit=10&intent=complementary")).then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      }).then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        return Array.from(html.querySelectorAll('[data-ed-upsell-item]'));
      })["catch"](function () {
        _this5._cache["delete"](productId);
        return [];
      });
      this._cache.set(productId, request);
      return request;
    }
  }, {
    key: "_render",
    value: function _render(items) {
      var _this$_list;
      var existing = new Map(Array.from(this._list.querySelectorAll('[data-ed-upsell-item]')).map(function (node) {
        return [node.dataset.productId, node];
      }));
      var nodes;
      if (this._keepOrder) {
        var allowed = new Set(items.map(function (node) {
          return node.dataset.productId;
        }));
        var kept = Array.from(existing.values()).filter(function (node) {
          return allowed.has(node.dataset.productId);
        });
        var added = items.filter(function (node) {
          return !existing.has(node.dataset.productId);
        }).map(function (node) {
          return node.cloneNode(true);
        });
        nodes = kept.concat(added).slice(0, this._config.limit);
      } else {
        nodes = items.map(function (node) {
          return existing.get(node.dataset.productId) || node.cloneNode(true);
        });
      }
      (_this$_list = this._list).replaceChildren.apply(_this$_list, _toConsumableArray(nodes));
      if (!this._keepOrder) {
        this._list.scrollLeft = 0;
      }
      this._keepOrder = false;
      this._wrapper.hidden = items.length === 0;
      if (items.length) {
        if (window.AOS) {
          window.AOS.refreshHard();
        }
        this._observeImpression();
      }
    }
  }, {
    key: "_observeImpression",
    value: function _observeImpression() {
      var _this6 = this;
      if (this._impressionTracked) return;
      if (!('IntersectionObserver' in window)) {
        this._trackImpression();
        return;
      }
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
      }
      this._intersectionObserver = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) {
          return entry.isIntersecting;
        })) {
          _this6._trackImpression();
        }
      }, {
        threshold: IMPRESSION_THRESHOLD
      });
      this._intersectionObserver.observe(this._list);
    }
  }, {
    key: "_trackImpression",
    value: function _trackImpression() {
      if (this._impressionTracked) return;
      this._impressionTracked = true;
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
      }
      var productIds = Array.from(this._list.querySelectorAll('[data-ed-upsell-item]')).map(function (node) {
        return node.dataset.productId;
      });
      this._track('impression', {
        productIds: productIds
      });
    }
  }, {
    key: "_track",
    value: function _track(action, detail) {
      document.dispatchEvent(new CustomEvent("ed:cart-upsell:".concat(action), {
        detail: detail
      }));
      if (window.ablyft && typeof window.ablyft.push === 'function') {
        window.ablyft.push({
          eventType: 'custom',
          eventName: "cart-upsell-".concat(action)
        });
      }
    }
  }, {
    key: "_onChange",
    value: function _onChange(event) {
      var select = event.target.closest('[data-ed-upsell-variant]');
      if (!select) return;
      var item = select.closest('[data-ed-upsell-item]');
      var option = select.options[select.selectedIndex];
      var button = item.querySelector('[data-ed-upsell-add]');
      var price = item.querySelector('[data-ed-upsell-price]');
      button.dataset.variantId = select.value;
      if (price && option && option.dataset.price) {
        price.textContent = option.dataset.price;
      }
    }
  }, {
    key: "_onClick",
    value: function _onClick(event) {
      var link = event.target.closest('[data-ed-upsell-link]');
      if (link) {
        var item = link.closest('[data-ed-upsell-item]');
        this._track('click', {
          productId: item ? item.dataset.productId : null
        });
        return;
      }
      var button = event.target.closest('[data-ed-upsell-add]');
      if (!button) return;
      event.preventDefault();
      this._addToCart(button);
    }
  }, {
    key: "_addToCart",
    value: function _addToCart(button) {
      var _this7 = this;
      if (button.classList.contains('btn--loading')) return;
      var item = button.closest('[data-ed-upsell-item]');
      var error = item.querySelector('[data-ed-upsell-error]');
      var variantId = parseInt(button.dataset.variantId, 10);
      button.classList.add('btn--loading');
      button.disabled = true;
      error.hidden = true;
      this._track('add', {
        productId: item.dataset.productId,
        variantId: variantId
      });
      fetch("".concat(routesRoot(), "cart/add.js"), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      }).then(function (response) {
        return response.json().then(function (data) {
          return {
            ok: response.ok,
            data: data
          };
        });
      }).then(function (_ref) {
        var ok = _ref.ok,
          data = _ref.data;
        if (!ok) {
          throw new Error(data.description || data.message || _this7._config.errorMessage);
        }
        _this7._removeItem(item);
      })["catch"](function (err) {
        button.classList.remove('btn--loading');
        button.disabled = false;
        error.textContent = err && err.message || _this7._config.errorMessage;
        error.hidden = false;
      });
    }
  }, {
    key: "_removeItem",
    value: function _removeItem(item) {
      var _this8 = this;
      var done = false;
      var finish = function finish() {
        if (done) return;
        done = true;
        item.remove();
        _this8._keepOrder = true;
        document.dispatchEvent(new CustomEvent('cart:build'));
      };
      item.addEventListener('transitionend', function (event) {
        if (event.target === item) finish();
      });
      setTimeout(finish, REMOVE_DURATION + 100);
      item.classList.add('is-removing');
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-cart-upsell')) {
  customElements.define('ed-cart-upsell', EdCartUpsell);
}

/***/ }),

/***/ "./src/js/modules/ed-reviews-sync.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-reviews-sync.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var DEFAULT_STORE = 'larkson-de';
var MAX_ATTEMPTS = 10;
var RETRY_DELAY = 500;
var HIDDEN_SOURCE_ID = 'ed-reviewsio-hidden-source';
function loadScript(src) {
  return new Promise(function (resolve, reject) {
    if (document.querySelector("script[src=\"".concat(src, "\"]"))) {
      resolve();
      return;
    }
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}
function convertStarsMarkup(starsMarkup) {
  if (!starsMarkup) return '';
  return starsMarkup.replace(/ricon-percentage-star--100/g, 'fa fa-star').replace(/stars__icon--100/g, 'fa fa-star').replace(/ricon-percentage-star--50/g, 'fa-star-half fa fa-star').replace(/stars__icon--50/g, 'fa-star-half fa fa-star').replace(/stars__icon/g, 'fa fa-star').replace(/<i class="[^"]*ricon[^"]*"[^>]*><\/i>/g, '').replace(/class="[^"]*R-RatingStars[^"]*"/g, 'class="ed-reviews-stars"');
}
function parseGermanNumber(value) {
  if (!value) return null;
  var normalized = value.replace(/\./g, '').replace(',', '.');
  var parsed = parseFloat(normalized);
  return Number.isNaN(parsed) ? null : parsed;
}
function formatGermanNumber(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return value.toLocaleString('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}
function getSourceRoot() {
  return document.querySelector("#".concat(HIDDEN_SOURCE_ID));
}
function isRatingValue(text) {
  var parsed = parseGermanNumber(text);
  return parsed !== null && parsed <= 5;
}
function getSourceData() {
  var source = getSourceRoot();
  if (!source) return null;
  var starsEl = source.querySelector('.R-RatingStars__stars, .CarouselWidget__header .R-RatingStars');
  var subheadingNumbers = source.querySelectorAll('.cssVar-subheading__number, .CarouselWidget__subheading .cssVar-subheading__number');
  if (!starsEl && subheadingNumbers.length === 0) return null;
  var rating = '';
  var count = '';
  subheadingNumbers.forEach(function (el) {
    var text = el.textContent.trim();
    if (!text) return;
    if (isRatingValue(text)) {
      rating = text;
      return;
    }
    if (!count) {
      count = text;
    }
  });
  return {
    stars: convertStarsMarkup(starsEl ? starsEl.innerHTML : ''),
    rating: rating,
    count: count
  };
}
function applySync(data) {
  var widgets = document.querySelectorAll('#text-banner-widget, [data-ed-reviews-widget]');
  if (!widgets.length || !data) return false;
  widgets.forEach(function (widget) {
    var minusAmount = parseInt(widget.dataset.minusAmount || '0', 10) || 0;
    var starsTarget = widget.querySelector('.ed-reviews-stars');
    var ratingTarget = widget.querySelector('.ed-reviews-rating');
    var countTarget = widget.querySelector('.ed-reviews-number');
    if (starsTarget && data.stars) {
      starsTarget.innerHTML = data.stars;
    }
    if (ratingTarget && data.rating) {
      ratingTarget.textContent = data.rating;
    }
    if (countTarget && data.count) {
      var parsedCount = parseGermanNumber(data.count);
      var adjustedCount = parsedCount !== null ? Math.max(0, parsedCount - minusAmount) : null;
      countTarget.textContent = adjustedCount !== null ? formatGermanNumber(adjustedCount) : data.count;
    }
    if (data.rating && data.count) {
      widget.classList.add('is-loaded');
      widget.removeAttribute('aria-busy');
    }
  });
  return Boolean(data.rating && data.count);
}
function ensureHiddenSource(_x) {
  return _ensureHiddenSource.apply(this, arguments);
}
function _ensureHiddenSource() {
  _ensureHiddenSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(store) {
    var container;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!document.querySelector("#".concat(HIDDEN_SOURCE_ID))) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          container = document.createElement('div');
          container.id = HIDDEN_SOURCE_ID;
          container.className = 'ed-reviewsio-hidden-source';
          container.setAttribute('aria-hidden', 'true');
          document.body.appendChild(container);
          _context.next = 9;
          return loadScript('https://widget.reviews.io/carousel-inline-iframeless/dist.js');
        case 9:
          if (!(typeof window.carouselInlineWidget !== 'function')) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return");
        case 11:
          window.carouselInlineWidget(HIDDEN_SOURCE_ID, {
            store: store,
            sku: '',
            lang: 'de',
            carousel_type: 'default',
            styles_carousel: 'CarouselWidget--sideHeader--withcards',
            options: {
              general: {
                review_type: 'company, product',
                min_reviews: '1',
                max_reviews: '5',
                enable_auto_scroll: false
              },
              header: {
                enable_overall_stars: true,
                rating_decimal_places: 2
              },
              reviews: {
                enable_customer_name: false,
                enable_verified_badge: false,
                hide_empty_reviews: true
              },
              popups: {
                enable_review_popups: false
              }
            }
          });
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ensureHiddenSource.apply(this, arguments);
}
function syncWithRetry() {
  var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var data = getSourceData();
  if (applySync(data)) return;
  if (attempt >= MAX_ATTEMPTS) return;
  setTimeout(function () {
    return syncWithRetry(attempt + 1);
  }, RETRY_DELAY);
}
var EdReviewsSync = /*#__PURE__*/function (_HTMLElement) {
  function EdReviewsSync() {
    _classCallCheck(this, EdReviewsSync);
    return _callSuper(this, EdReviewsSync, arguments);
  }
  _inherits(EdReviewsSync, _HTMLElement);
  return _createClass(EdReviewsSync, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      var store = this.dataset.store || DEFAULT_STORE;
      ensureHiddenSource(store).then(function () {
        return syncWithRetry();
      })["catch"](function () {
        return syncWithRetry();
      });
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-reviews-sync')) {
  customElements.define('ed-reviews-sync', EdReviewsSync);
}

/***/ }),

/***/ "./src/js/modules/logo-list-carousel.js":
/*!**********************************************!*\
  !*** ./src/js/modules/logo-list-carousel.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var LogoListCarousel = /*#__PURE__*/function (_HTMLElement) {
  function LogoListCarousel() {
    var _this;
    _classCallCheck(this, LogoListCarousel);
    _this = _callSuper(this, LogoListCarousel);
    _this.flickity = null;
    _this.track = null;
    _this.logoItems = [];
    _this.mobileMediaQuery = null;
    _this.handleBreakpointChange = _this.handleBreakpointChange.bind(_this);
    _this.handleBlockSelect = _this.handleBlockSelect.bind(_this);
    return _this;
  }
  _inherits(LogoListCarousel, _HTMLElement);
  return _createClass(LogoListCarousel, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.track = this.querySelector('[data-logo-list-track]');
      this.logoItems = Array.from(this.querySelectorAll('[data-logo-list-item]'));
      if (!this.track || this.logoItems.length < 2) {
        return;
      }
      var fallbackQuery = '(max-width: 768px)';
      var query = fallbackQuery;
      if (window.theme && window.theme.config && window.theme.config.mediaQuerySmall) {
        query = window.theme.config.mediaQuerySmall;
      }
      this.mobileMediaQuery = window.matchMedia(query);
      this.bindMediaQueryListener();
      this.updateSliderState();
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.destroySlider();
      this.unbindMediaQueryListener();
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }, {
    key: "bindMediaQueryListener",
    value: function bindMediaQueryListener() {
      if (!this.mobileMediaQuery) {
        return;
      }
      if (typeof this.mobileMediaQuery.addEventListener === 'function') {
        this.mobileMediaQuery.addEventListener('change', this.handleBreakpointChange);
        return;
      }
      if (typeof this.mobileMediaQuery.addListener === 'function') {
        this.mobileMediaQuery.addListener(this.handleBreakpointChange);
      }
    }
  }, {
    key: "unbindMediaQueryListener",
    value: function unbindMediaQueryListener() {
      if (!this.mobileMediaQuery) {
        return;
      }
      if (typeof this.mobileMediaQuery.removeEventListener === 'function') {
        this.mobileMediaQuery.removeEventListener('change', this.handleBreakpointChange);
        return;
      }
      if (typeof this.mobileMediaQuery.removeListener === 'function') {
        this.mobileMediaQuery.removeListener(this.handleBreakpointChange);
      }
    }
  }, {
    key: "handleBreakpointChange",
    value: function handleBreakpointChange() {
      this.updateSliderState();
    }
  }, {
    key: "updateSliderState",
    value: function updateSliderState() {
      if (!this.mobileMediaQuery) {
        return;
      }
      if (this.mobileMediaQuery.matches) {
        this.initSlider();
        return;
      }
      this.destroySlider();
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      if (this.flickity) {
        return;
      }
      if (typeof window.Flickity !== 'function') {
        return;
      }
      this.classList.add('is-mobile-slider');
      this.flickity = new window.Flickity(this.track, {
        cellSelector: '[data-logo-list-item]',
        prevNextButtons: false,
        pageDots: true,
        autoPlay: false,
        adaptiveHeight: false,
        wrapAround: this.logoItems.length > 2,
        cellAlign: 'center',
        contain: true,
        draggable: true
      });
    }
  }, {
    key: "destroySlider",
    value: function destroySlider() {
      if (this.flickity && typeof this.flickity.destroy === 'function') {
        this.flickity.destroy();
      }
      this.flickity = null;
      this.classList.remove('is-mobile-slider');
    }
  }, {
    key: "handleBlockSelect",
    value: function handleBlockSelect(event) {
      if (!this.flickity || !this.contains(event.target)) {
        return;
      }
      var cell = event.target.closest('[data-logo-list-item]');
      if (!cell) {
        return;
      }
      var index = parseInt(cell.dataset.index, 10);
      if (Number.isNaN(index)) {
        return;
      }
      this.flickity.select(index, false, true);
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!window.customElements.get('logo-list-carousel')) {
  window.customElements.define('logo-list-carousel', LogoListCarousel);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_accessibility_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/accessibility.js */ "./src/js/modules/accessibility.js");
/* harmony import */ var _modules_accessibility_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_accessibility_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_logo_list_carousel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/logo-list-carousel.js */ "./src/js/modules/logo-list-carousel.js");
/* harmony import */ var _modules_logo_list_carousel_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_logo_list_carousel_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_reviews_sync_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-reviews-sync.js */ "./src/js/modules/ed-reviews-sync.js");
/* harmony import */ var _modules_ed_reviews_sync_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_reviews_sync_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_cart_shipping_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-cart-shipping.js */ "./src/js/modules/ed-cart-shipping.js");
/* harmony import */ var _modules_ed_ab_lk_3_delivery_date_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-ab-lk-3-delivery-date.js */ "./src/js/modules/ed-ab-lk-3-delivery-date.js");
/* harmony import */ var _modules_ed_ab_lk_3_delivery_date_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_ab_lk_3_delivery_date_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_ed_ab_lk_5_sticky_atc_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-ab-lk-5-sticky-atc.js */ "./src/js/modules/ed-ab-lk-5-sticky-atc.js");
/* harmony import */ var _modules_ed_cart_upsell_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-cart-upsell.js */ "./src/js/modules/ed-cart-upsell.js");
/* harmony import */ var _modules_ed_cart_upsell_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_upsell_js__WEBPACK_IMPORTED_MODULE_6__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/








})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;